export default {
  methods: {
    getImage(img) {
      return require('../assets/' + img)
    },
    loadImage(url) {
      return new Promise((resolve) => {
        const image = new window.Image()
        image.crossOrigin = 'Anonymous'
        image.src = url + '?not-from-cache-please'
        image.onload = () => {
          resolve(image)
        }
      })
    }
  },
  computed: {
    currentLang() {
      return this.$i18n.locale
    },
    isDarkMode() {
      return this.$vuetify.theme.dark
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    globalTheme() {
      return this.$vuetify.theme.themes[this.isDarkMode ? 'dark' : 'light']
    }
  }
}
